// extracted by mini-css-extract-plugin
export default {"optionBlock":"LBeSDNBXMtJLP_REPj2b","deactivated":"d2lajJKJgw_3MHYWS5mN"};